import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import type {SuggestService} from '@yandex-delivery/api/service/suggest'
import type {PreOrderRetrieveResponse} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/api/pre-order'

import type {DestinationPoint} from '../../../../types'
import {DestinationPointDeliveryMethod} from '../../../../types'
import {fromPinDropToPointAddress} from '../../../../utils'
import {toParcels} from '../mappers/to-parcels'
import {toSuggestLocation} from '../mappers/to-suggest-location'

export const fetchDestinationPoints = async (
  {fetchAddressSuggest}: SuggestService,
  preOrderRetrieve: PreOrderRetrieveResponse,
): Promise<DestinationPoint[] | undefined> => {
  const destinationPoints = preOrderRetrieve.claim.route_points?.filter(
    point => point.type === 'destination',
  )

  if (!destinationPoints?.length) return

  const addressSuggests = await Promise.all(
    destinationPoints.map(point =>
      fetchAddressSuggest({
        point: toSuggestLocation(point.address.coordinates),
        type: 'b',
        location: toSuggestLocation(point.address.coordinates),
        action: SuggestAction.PIN_DROP,
      }),
    ),
  )

  return destinationPoints.map((point, i) => ({
    _type: 'destination',
    _deliveryMethod: DestinationPointDeliveryMethod.Address,
    dropOffPoint: {},
    cashOnDelivery: false,
    pickUpPoint: {},
    parcels: toParcels(preOrderRetrieve, point.point_id),
    paymentOnDelivery: false,
    _id: point.point_id,
    _visitOrder: point.visit_order,
    externalID: '',
    contact: point.contact,
    address: fromPinDropToPointAddress(addressSuggests[i]) ?? {},
  }))
}
